import styled from 'styled-components';

// Styled component to override disabled checkbox styling for better accessibility and UX
export const AccessibleCheckboxWrapper = styled.div`
  label[disabled] {
    color: ${p => p.theme.colors.black} !important;
  }

  label[disabled] > div:first-child {
    background: #f1f1f1 !important;
    border: 1px solid #e3e3e3 !important;
  }

  .qBPTW[disabled] {
    background: #f1f1f1 !important;
    border: 1px solid #e3e3e3 !important;
  }
`;
